import _ from 'lodash';

export function hasPluginOfType(editor, type) {
  return !!editor && _.some(editor.plugins, p => p.type === type);
}
